"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipMessage = TooltipMessage;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _Link = require("../Link");

var _excluded = ["title", "desc", "links"],
    _excluded2 = ["title"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Title = /*#__PURE__*/(0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qezuau4"
} : {
  target: "e1qezuau4",
  label: "Title"
})("font-weight:", _styles.typography.weight.bold, ";");
var Desc = /*#__PURE__*/(0, _theming.styled)("span", process.env.NODE_ENV === "production" ? {
  target: "e1qezuau3"
} : {
  target: "e1qezuau3",
  label: "Desc"
})();
var Links = /*#__PURE__*/(0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qezuau2"
} : {
  target: "e1qezuau2",
  label: "Links"
})("margin-top:8px;text-align:center;>*{margin:0 8px;font-weight:", _styles.typography.weight.bold, ";}");
var Message = /*#__PURE__*/(0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qezuau1"
} : {
  target: "e1qezuau1",
  label: "Message"
})("color:", _styles.color.darker, ";line-height:18px;");
var MessageWrapper = /*#__PURE__*/(0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qezuau0"
} : {
  target: "e1qezuau0",
  label: "MessageWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1r53aed",
  styles: "padding:15px;width:280px;box-sizing:border-box;word-break:break-word"
} : {
  name: "1r53aed",
  styles: "padding:15px;width:280px;box-sizing:border-box;word-break:break-word",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

function TooltipMessage(_ref) {
  var title = _ref.title,
      desc = _ref.desc,
      links = _ref.links,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(MessageWrapper, rest, /*#__PURE__*/_react["default"].createElement(Message, null, title && /*#__PURE__*/_react["default"].createElement(Title, null, title), desc && /*#__PURE__*/_react["default"].createElement(Desc, null, desc)), links && links.length > 0 && /*#__PURE__*/_react["default"].createElement(Links, null, links.map(function (_ref2) {
    var linkTitle = _ref2.title,
        other = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(_Link.Link, (0, _extends2["default"])({}, other, {
      key: linkTitle
    }), linkTitle);
  })));
}